const initData = {
  schForm: {
    pg: 1,
    pgSz: 10,
    schFld: "whle",
    schTxt: "",
    schStrtYmd: "",
    schEndYmd: "",
    schTp: 1,
    schStore: "",
  },
  noticeList: "",
  initState: false,
  loading: true,
};

let initialState = {
  ...JSON.parse(JSON.stringify(initData)),
};

export const LOADING = "LOADING";
export const loadingAction = (data) => ({
  type: LOADING,
  payload: data,
});

// export const SET_FORM_NOTICE = "SET_FORM_NOTICE";
// export const schFormNoticeAction = (data) => ({
//   type: SET_FORM_NOTICE,
//   payload: data,
// });

export const LOAD_NOTICE_LIST = "LOAD_NOTICE_LIST";
export const loadNoticeListAction = (data) => ({
  type: LOAD_NOTICE_LIST,
  payload: data,
});

export const LOAD_NOTICE_LIST_SUCCESS = "LOAD_NOTICE_LIST_SUCCESS";
export const loadNoticeListSuccessAction = (list) => ({
  type: LOAD_NOTICE_LIST_SUCCESS,
  payload: list,
});

export const RESET = "RESET";
export const reset = () => ({
  type: RESET,
  payload: initData,
});

export default function NoticeReducer(state = initialState, action) {
  const { type, payload, error } = action;

  console.log("noticeReducer = type", type, "payload", payload);
  console.log("statestatestatestate", state);

  switch (type) {
    case LOADING:
      return {
        ...state,
        loading: payload,
      };

    // case SET_FORM_NOTICE:
    //   return {
    //     ...state,
    //     schForm: payload,
    //   };
    case LOAD_NOTICE_LIST:
      return {
        ...state,
        schForm: payload,
      };
    case LOAD_NOTICE_LIST_SUCCESS:
      return {
        ...state,
        noticeList: payload,
        loading: false,
      };
    case RESET:
      return {
        ...payload,
      };
    default:
      return state;
  }
}
